/** @format */

/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';

import { configureAmplify } from '../../shared/bootstrap/amplify.bootstrap';
import { getLocalRestEndpoint } from '../../shared/bootstrap/local-rest-endpoint';
import { bootstrapAngularApp } from '../../shared/bootstrap/platform.bootstrap';
import { initializeSentry } from '../../shared/bootstrap/sentry.bootstrap';
// import AmplifyConfig from '../../shared/config/amplifyconfiguration.json';
import { SessionData } from '../../shared/session/app.session.data';
import AmplifyConfig from './amplifyconfiguration.json';
import { environment } from './environments/environment';
import sentryInfo from './sentry-info';

environment.region = AmplifyConfig['aws_project_region'];

const endpoint = environment.env === 'locale' ? getLocalRestEndpoint(window.location.port) : `https://${environment.env}-api.sesio.io`;

configureAmplify(AmplifyConfig as Record<string, any>, {
  customRestApi: { name: 'sesiorest', endpoint },
  onConfigured: (): void => SessionData.$amplifyReady.next(true),
});

initializeSentry({
  debug: false,
  dsn: 'https://aa2aadaad7ac4013622043d5570add42@o4506081162166272.ingest.sentry.io/4506082455388160',
  environment: environment.env,
  release: environment.env === 'locale' ? undefined : sentryInfo.release,
  tracePropagationTargets: [`https://${environment.env}-api.sesio.io`],
  excludedRejections: [
    'The user is not authenticated',
    'User needs to be authenticated to call this API.',
    "Cannot read properties of null (reading 'dispose')",
    'network error',
    'AMQJS0011E Invalid state not connected.',
  ],
  isDisabled: environment.env === 'locale',
});

if (environment.production) enableProdMode();

bootstrapAngularApp(import('./app/app.module')).catch(err => console.error(err));
